// Page-level loading overlay for list pages (dashboard, captures): the SAME
// overlay the scene load uses — #upload-overlay in public/index.html (dimmed
// background below the header + the spinning ring, styles.css) — in its
// indeterminate, spinner-only state: no percentage.
//
// Reference-counted, so overlapping loads on one page can't hide it early.

let activeCount = 0;

function overlayEls() {
  return {
    overlay: document.getElementById('upload-overlay'),
    ring: document.getElementById('loading-ring'),
    arc: document.getElementById('loading-ring-arc'),
    percent: document.getElementById('loading-percent'),
  };
}

export function showPageLoading() {
  activeCount += 1;
  const { overlay, ring, arc, percent } = overlayEls();
  if (!overlay) return;
  // Same reset as SceneHandler's spinner(true): indeterminate spinning arc.
  if (ring) ring.classList.remove('is-determinate');
  if (arc) arc.setAttribute('stroke-dasharray', '40 123.36');
  if (percent) percent.textContent = '';
  overlay.style.display = 'flex';
  document.body.classList.add('upload-active');
}

export function hidePageLoading() {
  activeCount = Math.max(0, activeCount - 1);
  if (activeCount > 0) return;
  const { overlay } = overlayEls();
  if (overlay) overlay.style.display = 'none';
  const status = document.getElementById('loading-status');
  if (status) status.textContent = '';
  document.body.classList.remove('upload-active');
}

// Resolves once every <img> under `root` that's currently on screen has
// loaded (or failed), capped at `timeoutMs`. Off-screen lazy images are
// ignored — they don't load until scrolled to, and shouldn't hold the page.
export function waitForVisibleImages(root, timeoutMs = 8000) {
  if (!root) return Promise.resolve();
  const vh = window.innerHeight || document.documentElement.clientHeight;
  const pending = [...root.querySelectorAll('img')].filter((img) => {
    if (img.complete) return false;
    const r = img.getBoundingClientRect();
    return r.bottom > 0 && r.top < vh;
  });
  if (pending.length === 0) return Promise.resolve();
  const loads = pending.map((img) => new Promise((resolve) => {
    img.addEventListener('load', resolve, { once: true });
    img.addEventListener('error', resolve, { once: true });
  }));
  return Promise.race([
    Promise.all(loads),
    new Promise((resolve) => setTimeout(resolve, timeoutMs)),
  ]);
}
